<script lang="ts" setup>
import { ref } from 'vue';

import { KaButton } from '@/kasten-components/components/KaButton';
import type { MaybePromise } from '@/kasten-components/types';

import { injectMultiStepFormContext, type Step } from './model';

const {
  onNext: onTriggerNext,
  isFirstStep,
  isLastStep,
  currentStep,
  nextStep,
} = injectMultiStepFormContext();

const props = defineProps<{
  onNext: (currentStep: Step, nexStep?: Step) => MaybePromise<boolean>;
}>();

const loading = ref(false);

const handleClick = async () => {
  loading.value = true;
  if (await props.onNext(currentStep.value, nextStep.value)) {
    onTriggerNext();
  }
  loading.value = false;
};
</script>
<template>
  <KaButton
    variant="primary"
    class="max-sm:flex-grow"
    :loading="loading"
    data-testid="multiStepNext"
    @click="handleClick"
  >
    <slot :loading="loading" :last-step="isLastStep" :first-step="isFirstStep">
      {{ isLastStep ? 'Submit' : 'Next' }}
    </slot>
    <span class="sr-only">
      <template v-if="isLastStep">, Complete and submit the multi-step form.</template>
      <template v-else>, Proceed to {{ nextStep?.name }}.</template>
    </span>
  </KaButton>
</template>
